module.exports = __webpack_public_path__ + "img/frontiers-background-full.2caecef5.jpg";